<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.293 15.629L15.619 5.303C16.009 4.913 16.642 4.913 17.032 5.303L18.708 6.979C19.098 7.369 19.098 8.002 18.708 8.392L8.381 18.717C8.194 18.905 7.94 19.01 7.675 19.01H5V16.335C5 16.07 5.105 15.816 5.293 15.629Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.75 7.17001L16.84 10.26"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
